import {reducerFactory} from '../../lib/asyncUtil'
import {ROLES} from '../actionTypes'

export default reducerFactory(ROLES)
